import React from "react";
import module from "./InitGoogleLoginButton.module.css";
import PrimaryLinkButton from "./PrimaryLinkButton";

const InitGoogleLoginButton = ({ disabled = false }) => {
  return (
    <div className={module.initLogin}>
      <PrimaryLinkButton
        variant="outlined"
        label={"新規募集は現在停止中です"}
        to={"/signup"}
        disabled={disabled}
      />
    </div>
  );
};

export default InitGoogleLoginButton;
